var map = {
	"./note1.mp3": 9132,
	"./note10.mp3": 8334,
	"./note11.mp3": 9533,
	"./note12.mp3": 234,
	"./note13.mp3": 8368,
	"./note14.mp3": 4554,
	"./note15.mp3": 7276,
	"./note16.mp3": 9676,
	"./note17.mp3": 8254,
	"./note18.mp3": 4862,
	"./note19.mp3": 9229,
	"./note2.mp3": 2810,
	"./note20.mp3": 7845,
	"./note21.mp3": 4612,
	"./note22.mp3": 6653,
	"./note23.mp3": 736,
	"./note24.mp3": 1960,
	"./note25.mp3": 8341,
	"./note26.mp3": 220,
	"./note27.mp3": 240,
	"./note28.mp3": 5379,
	"./note29.mp3": 6867,
	"./note3.mp3": 8598,
	"./note30.mp3": 6586,
	"./note31.mp3": 7801,
	"./note32.mp3": 490,
	"./note33.mp3": 5342,
	"./note34.mp3": 2643,
	"./note35.mp3": 9457,
	"./note36.mp3": 4843,
	"./note4.mp3": 7778,
	"./note5.mp3": 5670,
	"./note6.mp3": 1721,
	"./note7.mp3": 7860,
	"./note8.mp3": 5052,
	"./note9.mp3": 1503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5225;